import { render } from "./QuickBriefCollabList.vue?vue&type=template&id=43dfa3a0&scoped=true"
import script from "./QuickBriefCollabList.vue?vue&type=script&lang=js"
export * from "./QuickBriefCollabList.vue?vue&type=script&lang=js"

import "./QuickBriefCollabList.vue?vue&type=style&index=0&id=43dfa3a0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43dfa3a0"]])

export default __exports__